import type { OnChanges, SimpleChanges } from '@angular/core';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import type { AvatarSize } from '@core/user-interface-legacy';
import { AvatarComponent } from '@core/user-interface-legacy';

import type {
  NoteAvatarAuthor,
  NoteAvatarInputValues,
  NoteAvatarUpdateStrategy,
} from './note-avatar.types';
import { NOTE_AVATAR_UPDATE_STRATEGY } from './note-avatar.types';

@Component({
  selector: 'rt-note-avatar',
  imports: [AvatarComponent],
  templateUrl: './note-avatar.component.html',
  styleUrls: ['./note-avatar.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoteAvatarComponent implements OnChanges {
  private readonly updateStrategy = inject<NoteAvatarUpdateStrategy>(NOTE_AVATAR_UPDATE_STRATEGY);

  public readonly author = input<NoteAvatarAuthor | null>(undefined!);

  public readonly triggered = input<boolean | null>(undefined!);

  public readonly size = input<AvatarSize>('base');

  public data: NoteAvatarInputValues;

  public ngOnChanges(changes: SimpleChanges) {
    if ('author' in changes || 'triggered' in changes) {
      this.data = this.updateStrategy.getValues({
        author: this.author(),
        triggered: this.triggered(),
      });
    }
  }
}
